import React from 'react'
import { FaWhatsapp } from "react-icons/fa6";
import { IoLocationOutline } from "react-icons/io5";
import { TfiEmail } from "react-icons/tfi";
import { FaAngleDoubleRight } from "react-icons/fa";
import './address.css';
import {footerlogo} from '../data.js';
import LazyImage from '../../LazyImage.jsx';

function Address (props) {
    // const{logo}=props.ftrlogo
    // console.log('add',logo)
    const logo = footerlogo.logo;
  return (
    <div className='address'>
        <div className="container add-container">
            <div className="row">
                <div className="col-md-3 col-sm-4 headers">
                    <a href='/'><LazyImage src={logo} alt="footer-Logo" className='h-1'/></a>
                    <h6>"Empowering Futures Through Practical Learning."</h6>
                    <div><h5 className='h-2'>Adarsh</h5> <span> is a leading software training institute offering expert-led courses, hands-on project guidance, and fully equipped labs.</span>
                         </div>
                         <h6>Our expert trainer specialize in industry-relevant courses</h6>
                </div>
                <div className="col-md-3 col-sm-4 headers">
                    <h3 className='footer-title'>Getting in touch</h3>
                    <div className='h-3'>
                        <div style={{display: 'grid', gap: '10px'}}>
                            <FaWhatsapp className='fa-icon'/><span className='fa-txt'><a className='footer-2s-links' href='https://web.whatsapp.com/send?phone=9494760846&text=Hi%2C%20we%20are%20interested%20to%20join%20in%20your%20institute.%20Need%20some%20info.' target='blank'>+91 99494760846&nbsp;|&nbsp;+91 8019812384</a></span>
                            {/* <TfiEmail className='fa-icon'/><span className='fa-txt'><a className='footer-2s-links' href='mailto:aadarshmaltiskills2@gmail.com?subject=Admission%20Enquiry&body=Hi%2C%20we%20are%20interested%20to%20join%20in%20your%20institute.%20Please%20share%20details.'>chandu842@gmail.com</a></span> */}
                            <TfiEmail className='fa-icon'/><span className='fa-txt'><a className='footer-2s-links' href='https://mail.google.com/mail/?view=cm&to=aadarshmaltiskills2@gmail.com&su=Admission%20Enquiry&body=Hi%2C%20we%20are%20interested%20to%20join%20in%20your%20institute.%20Please%20share%20details.' target='blank'>aadarshmaltiskills2@gmail.com</a></span>
                            <IoLocationOutline className='fa-icon'/>
                            <span className='fa-txt1'><a className='footer-2s-links' href='https://www.google.com/maps/place/Aadarsh+Malti+Skills/@16.6434756,80.5509733,11.98z/data=!4m6!3m5!1s0x3a35ebe322aa5ccb:0xabe38ca7549d3b3b!8m2!3d16.6148797!4d80.5401213!16s%2Fg%2F11cr_np8jm?hl=en&entry=ttu&g_ep=EgoyMDI1MDcxNi4wIKXMDSoASAFQAw%3D%3D' target='blank'>Near Ravindra Bharathi School, Main Road Kondapalli,Vijayawada<br/>521228</a></span>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-4 headers">
                    <div className='h-4'>
                    <h3 className='footer-title'>Useful links</h3>
                    <div>
                    <p><FaAngleDoubleRight /><span><a href='/trainer-profile' className='footer-links'>Trainer Profile</a></span></p>
                    <p><FaAngleDoubleRight /><span><a href='/our-courses' className='footer-links'>Our Courses</a></span></p>
                    <p><FaAngleDoubleRight /><span><a href='/student-works' className='footer-links'>Student Works</a></span></p>
                    <p><FaAngleDoubleRight /><span><a href='/contact-us' className='footer-links'>Contact Us</a></span></p>
                    <p><FaAngleDoubleRight /><span><a href='/register-now' className='footer-links'>Register Now!</a></span></p>
                    <p className='footer-quiz'><FaAngleDoubleRight /><span><a href='/quiz-loginPage' className='footer-links'>Quiz!</a></span></p>
                    </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-4 headers-btm">
                    <div className='h-4'>
                    <h3 className='footer-title'> Timings</h3>

                    <div>
                        <p>Mon-Sat: &emsp;&emsp;&emsp;08AM - 10PM</p>
                        <p>Sunday: &emsp;&emsp;&emsp;&nbsp;Holiday</p>
                    </div>

                    <div>
                    <h3 className='footer-title'>Location</h3>
                    <div>
						<iframe title="Adarsh Malti Skills Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d61178.11254297552!2d80.53115042705674!3d16.595019414381795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35ebe322aa5ccb%3A0xabe38ca7549d3b3b!2sAadarsh%20Malti%20Skills!5e0!3m2!1sen!2sin!4v1644262770317!5m2!1sen!2sin" className='iframe' allowFullScreen="" loading="lazy"></iframe>
					</div>
                    </div>
                    
                </div>    
                </div>
            </div>
                <div className="copyRt">
                    <h6>Copy Rights &copy; Under Government Act Reg. No. 158 2016</h6>
                    <h6>&copy; {new Date().getFullYear()} Adarsh &mdash; Designed &amp; Developed by{' '}
                        <a href="https://karthik-p-mac-portfolio.vercel.app/" target="_blank" rel="noopener noreferrer" className="footer-links">
                            Karthik Potti
                        </a>
                    </h6>
                </div>
        </div>
    </div>
  )
}

export default Address